"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var checkIsIntegerNumber = function (value) { return (!!value && /^([0-9]+)$/.test(value)); };
exports.default = checkIsIntegerNumber;
